import { ITheme } from "../../../theme";
import { ThemeStyle } from "../../Style.types";
import { adjustColor } from "../../lib";

export interface IColorClassGroup {
  colorPrimaryMain: ThemeStyle;
  colorPrimaryLight: ThemeStyle;
  colorPrimaryDark: ThemeStyle;
  colorPrimaryContrast: ThemeStyle;
  colorSecondaryMain: ThemeStyle;
  colorSecondaryLight: ThemeStyle;
  colorSecondaryDark: ThemeStyle;
  colorSecondaryContrast: ThemeStyle;
  colorSuccessMain: ThemeStyle;
  colorSuccessLight: ThemeStyle;
  colorSuccessDark: ThemeStyle;
  colorSuccessContrast: ThemeStyle;
  colorWarningMain: ThemeStyle;
  colorWarningLight: ThemeStyle;
  colorWarningDark: ThemeStyle;
  colorWarningContrast: ThemeStyle;
  colorDangerMain: ThemeStyle;
  colorDangerLight: ThemeStyle;
  colorDangerDark: ThemeStyle;
  colorDangerContrast: ThemeStyle;
  colorInfoMain: ThemeStyle;
  colorInfoLight: ThemeStyle;
  colorInfoDark: ThemeStyle;
  colorInfoContrast: ThemeStyle;
  colorNeutralLighterMain: ThemeStyle;
  colorNeutralLighterLight: ThemeStyle;
  colorNeutralLighterDark: ThemeStyle;
  colorNeutralLighterContrast: ThemeStyle;
  colorNeutralDarkerMain: ThemeStyle;
  colorNeutralDarkerLight: ThemeStyle;
  colorNeutralDarkerDark: ThemeStyle;
  colorNeutralDarkerContrast: ThemeStyle;
  bgPrimaryMain: ThemeStyle;
  bgPrimaryLight: ThemeStyle;
  bgPrimaryDark: ThemeStyle;
  bgPrimaryContrast: ThemeStyle;
  bgSecondaryMain: ThemeStyle;
  bgSecondaryLight: ThemeStyle;
  bgSecondaryDark: ThemeStyle;
  bgSecondaryContrast: ThemeStyle;
  bgSuccessMain: ThemeStyle;
  bgSuccessLight: ThemeStyle;
  bgSuccessDark: ThemeStyle;
  bgSuccessContrast: ThemeStyle;
  bgWarningMain: ThemeStyle;
  bgWarningLight: ThemeStyle;
  bgWarningDark: ThemeStyle;
  bgWarningContrast: ThemeStyle;
  bgDangerMain: ThemeStyle;
  bgDangerLight: ThemeStyle;
  bgDangerDark: ThemeStyle;
  bgDangerContrast: ThemeStyle;
  bgInfoMain: ThemeStyle;
  bgInfoLight: ThemeStyle;
  bgInfoDark: ThemeStyle;
  bgInfoContrast: ThemeStyle;
  bgNeutralLighterMain: ThemeStyle;
  bgNeutralLighterLight: ThemeStyle;
  bgNeutralLighterDark: ThemeStyle;
  bgNeutralLighterContrast: ThemeStyle;
  bgNeutralDarkerMain: ThemeStyle;
  bgNeutralDarkerLight: ThemeStyle;
  bgNeutralDarkerDark: ThemeStyle;
  bgNeutralDarkerContrast: ThemeStyle;
  bgDangerWashed: ThemeStyle;
  bgWarningWashed: ThemeStyle;
  bgSuccessWashed: ThemeStyle;
  bgInfoWashed: ThemeStyle;
  bgPrimaryWashed: ThemeStyle;
  bgSecondaryWashed: ThemeStyle;
}

export const ColorClassGroup: IColorClassGroup = {
  colorPrimaryMain: (theme) => ({
    color: theme.colors.primary.main,
  }),
  colorPrimaryLight: (theme) => ({
    color: theme.colors.primary.light,
  }),
  colorPrimaryDark: (theme) => ({
    color: theme.colors.primary.dark,
  }),
  colorPrimaryContrast: (theme) => ({
    color: theme.colors.primary.contrast,
  }),
  colorSecondaryMain: (theme) => ({
    color: theme.colors.secondary.main,
  }),
  colorSecondaryLight: (theme) => ({
    color: theme.colors.secondary.light,
  }),
  colorSecondaryDark: (theme) => ({
    color: theme.colors.secondary.dark,
  }),
  colorSecondaryContrast: (theme) => ({
    color: theme.colors.secondary.contrast,
  }),
  colorSuccessMain: (theme) => ({
    color: theme.colors.success.main,
  }),
  colorSuccessLight: (theme) => ({
    color: theme.colors.success.light,
  }),
  colorSuccessDark: (theme) => ({
    color: theme.colors.success.dark,
  }),
  colorSuccessContrast: (theme) => ({
    color: theme.colors.success.contrast,
  }),
  colorWarningMain: (theme) => ({
    color: theme.colors.warning.main,
  }),
  colorWarningLight: (theme) => ({
    color: theme.colors.warning.light,
  }),
  colorWarningDark: (theme) => ({
    color: theme.colors.warning.dark,
  }),
  colorWarningContrast: (theme) => ({
    color: theme.colors.warning.contrast,
  }),
  colorDangerMain: (theme) => ({
    color: theme.colors.danger.main,
  }),
  colorDangerLight: (theme) => ({
    color: theme.colors.danger.light,
  }),
  colorDangerDark: (theme) => ({
    color: theme.colors.danger.dark,
  }),
  colorDangerContrast: (theme) => ({
    color: theme.colors.danger.contrast,
  }),
  colorInfoMain: (theme) => ({
    color: theme.colors.info.main,
  }),
  colorInfoLight: (theme) => ({
    color: theme.colors.info.light,
  }),
  colorInfoDark: (theme) => ({
    color: theme.colors.info.dark,
  }),
  colorInfoContrast: (theme) => ({
    color: theme.colors.info.contrast,
  }),
  colorNeutralLighterMain: (theme: ITheme) => ({
    color: theme.colors.neutralLighter.main,
  }),
  colorNeutralLighterLight: (theme: ITheme) => ({
    color: theme.colors.neutralLighter.light,
  }),
  colorNeutralLighterDark: (theme: ITheme) => ({
    color: theme.colors.neutralLighter.dark,
  }),
  colorNeutralLighterContrast: (theme: ITheme) => ({
    color: theme.colors.neutralLighter.contrast,
  }),
  colorNeutralDarkerMain: (theme: ITheme) => ({
    color: theme.colors.neutralDarker.main,
  }),
  colorNeutralDarkerLight: (theme: ITheme) => ({
    color: theme.colors.neutralDarker.light,
  }),
  colorNeutralDarkerDark: (theme: ITheme) => ({
    color: theme.colors.neutralDarker.dark,
  }),
  colorNeutralDarkerContrast: (theme: ITheme) => ({
    color: theme.colors.neutralDarker.contrast,
  }),
  bgPrimaryMain: (theme) => ({
    backgroundColor: theme.colors.primary.main,
  }),
  bgPrimaryLight: (theme) => ({
    backgroundColor: theme.colors.primary.light,
  }),
  bgPrimaryDark: (theme) => ({
    backgroundColor: theme.colors.primary.dark,
  }),
  bgPrimaryContrast: (theme) => ({
    backgroundColor: theme.colors.primary.contrast,
  }),
  bgPrimaryWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.primary.main, 1, 0.15),
  }),
  bgSecondaryMain: (theme) => ({
    backgroundColor: theme.colors.secondary.main,
  }),
  bgSecondaryLight: (theme) => ({
    backgroundColor: theme.colors.secondary.light,
  }),
  bgSecondaryDark: (theme) => ({
    backgroundColor: theme.colors.secondary.dark,
  }),
  bgSecondaryContrast: (theme) => ({
    backgroundColor: theme.colors.secondary.contrast,
  }),
  bgSecondaryWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.secondary.main, 1, 0.15),
  }),
  bgSuccessMain: (theme) => ({
    backgroundColor: theme.colors.success.main,
  }),
  bgSuccessLight: (theme) => ({
    backgroundColor: theme.colors.success.light,
  }),
  bgSuccessDark: (theme) => ({
    backgroundColor: theme.colors.success.dark,
  }),
  bgSuccessContrast: (theme) => ({
    backgroundColor: theme.colors.success.contrast,
  }),
  bgSuccessWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.success.main, 1, 0.15),
  }),
  bgWarningMain: (theme) => ({
    backgroundColor: theme.colors.warning.main,
  }),
  bgWarningLight: (theme) => ({
    backgroundColor: theme.colors.warning.light,
  }),
  bgWarningDark: (theme) => ({
    backgroundColor: theme.colors.warning.dark,
  }),
  bgWarningContrast: (theme) => ({
    backgroundColor: theme.colors.warning.contrast,
  }),
  bgWarningWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.warning.main, 1, 0.15),
  }),
  bgDangerMain: (theme) => ({
    backgroundColor: theme.colors.danger.main,
  }),
  bgDangerLight: (theme) => ({
    backgroundColor: theme.colors.danger.light,
  }),
  bgDangerDark: (theme) => ({
    backgroundColor: theme.colors.danger.dark,
  }),
  bgDangerContrast: (theme) => ({
    backgroundColor: theme.colors.danger.contrast,
  }),
  bgDangerWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.danger.main, 1, 0.15),
  }),
  bgInfoMain: (theme) => ({
    backgroundColor: theme.colors.info.main,
  }),
  bgInfoLight: (theme) => ({
    backgroundColor: theme.colors.info.light,
  }),
  bgInfoDark: (theme) => ({
    backgroundColor: theme.colors.info.dark,
  }),
  bgInfoContrast: (theme) => ({
    backgroundColor: theme.colors.info.contrast,
  }),
  bgInfoWashed: (theme) => ({
    backgroundColor: adjustColor(theme.colors.info.main, 1, 0.15),
  }),
  bgNeutralLighterMain: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralLighter.main,
  }),
  bgNeutralLighterLight: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralLighter.light,
  }),
  bgNeutralLighterDark: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralLighter.dark,
  }),
  bgNeutralLighterContrast: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralLighter.contrast,
  }),
  bgNeutralDarkerMain: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralDarker.main,
  }),
  bgNeutralDarkerLight: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralDarker.light,
  }),
  bgNeutralDarkerDark: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralDarker.dark,
  }),
  bgNeutralDarkerContrast: (theme: ITheme) => ({
    backgroundColor: theme.colors.neutralDarker.contrast,
  }),
};
